.container {
  border-radius: 24px;
  background: #f3eddf;
  padding: 24px 0px 24px 0;
  position: relative;
}

.label {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 32px;
  border: 0.5px solid rgb(255, 255, 255);
  background: #AE66F6;
  box-shadow: 1px -3px 16px 0 rgba(255, 255, 255, 0.60) inset;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 5px 10px 5px 12px;

  p {
    color: #FFFBF2;
    font-family: ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: 0.068px;
    text-transform: uppercase;
    white-space: nowrap;
  }

  img {
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
  }
}

.title {
  color: #231e19;
  text-align: center;
  font-family: ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif;
  font-size: 19px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.076px;
  margin-bottom: 8px;
  padding: 0 16px;
}

.subtitle {
  color: #7b766f;
  text-align: center;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.045px;
  padding: 0 16px;
}

.chart {
  position: relative;
}

.chartDivision {
  height: 36px;
  border-bottom: 1px dashed #dad2c4;
}

.chartItemWrapper {
  width: 100%;
  position: absolute;
  padding: 0 19px;
  display: flex;
  justify-content: space-between;
  bottom: 0;
  left: 0;
  align-items: flex-end;
}

.chartItems {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 4px;
}

.chartItem {
  flex: 1;
  min-width: 26px;
  max-width: 26px;
  border-radius: 32px 32px 0px 0px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 5px;

  &:nth-child(3) {
    margin: 0 10px;
  }
}

.logo {
  width: 16px;
  height: 16px;
  max-width: 16px;
  max-height: 16px;
  border-radius: 50%;
}

.chartDescription {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 19px;
  margin-top: 12px;

  p {
    color: #7b766f;
    font-family: ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
      sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: 0.048px;
    text-align: center;
    width: 56px;
  }
}

.description {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 0 16px;
  margin-top: 24px;

  p {
    color: #231e19;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: -0.036px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 6px;
  }

  p:first-child::before {
    content: '';
    display: block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: linear-gradient(180deg, #2aa174 0%, #c7d239 100%);
  }

  p:last-child::before {
    content: '';
    display: block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #beb9ad;
  }
}

// Dark mode
:global body.dark {
  :local {
    .container {
      background: #2a2928;
    }

    .title,
    .subtitle,
    .description p {
      color: #fffbf2;
    }

    .chartDivision {
      border-color: #3e3c3a;
    }

    .description {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 20px;
      padding: 0 16px;
      margin-top: 24px;

      p:last-child::before {
        background: #585552;
      }
    }
  }
}
